/* Nbloop: shared accessible interactions. Event delegation survives editor reloads. */
(() => {
  'use strict';
  if (window.Nbloop) return;
  const TF = window.Nbloop = {};
  TF.root = () => window.Shopify?.routes?.root || '/';
  TF.say = message => { const live = document.getElementById('nl-live'); if (live) live.textContent = message; };
  TF.openDialog = (dialog, trigger) => {
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    if (dialog.open) return true;
    dialog._tfTrigger = trigger || document.activeElement;
    dialog.showModal();
    document.body.classList.add('nl-modal-open');
    return true;
  };
  TF.closeDialog = dialog => { if (dialog?.open) dialog.close(); };
  document.addEventListener('close', event => {
    if (!(event.target instanceof HTMLDialogElement)) return;
    if (!document.querySelector('dialog[open]')) document.body.classList.remove('nl-modal-open');
    const trigger = event.target._tfTrigger;
    if (trigger?.isConnected) trigger.focus();
  }, true);
  document.addEventListener('click', event => {
    const close = event.target.closest('[data-dialog-close]');
    if (close) TF.closeDialog(close.closest('dialog'));
    if (event.target instanceof HTMLDialogElement) {
      const box = event.target.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) TF.closeDialog(event.target);
    }
    document.querySelectorAll('.nl-nav-details[open]').forEach(details => {
      if (!details.contains(event.target)) details.open = false;
    });
    const menu = document.querySelector('.nl-mobile-menu[open]');
    if (menu && !menu.contains(event.target)) menu.open = false;
  });
  document.addEventListener('keydown', event => {
    const menu = document.querySelector('.nl-mobile-menu[open]');
    if (event.key === 'Escape') {
      const accordion = event.target.closest('.nl-accordion[open]');
      if (accordion) { accordion.open = false; accordion.querySelector('summary')?.focus(); }
      document.querySelectorAll('.nl-nav-details[open]').forEach(d => { d.open = false; });
      if (menu) { menu.open = false; menu.querySelector('summary')?.focus(); }
    }
    if (event.key === 'Tab' && menu) {
      const candidates = [...menu.querySelectorAll('a[href],button:not([disabled]),summary,input:not([disabled])')].filter(el => el.getClientRects().length);
      const first = candidates[0], last = candidates[candidates.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    }
  });
  TF.init = (scope = document) => {
    scope.querySelectorAll('.nl-header').forEach(header => header.closest('.shopify-section')?.classList.toggle('nl-header-section--sticky', header.dataset.sticky === 'true'));
    const header = document.querySelector('.nl-header');
    if (header) document.body.style.setProperty('--nl-header-height', `${header.offsetHeight}px`);
    if (document.body.dataset.animation === 'true' && 'IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('nl-reveal'); observer.unobserve(entry.target); }
      }), { threshold:0.08 });
      scope.querySelectorAll('.nl-section-heading,.nl-value,.nl-benefit').forEach(el => observer.observe(el));
    }
  };
  let scheduled = false;
  addEventListener('resize', () => {
    const header = document.querySelector('.nl-header');
    if (header) document.body.style.setProperty('--nl-header-height', `${header.offsetHeight}px`);
  }, { passive:true });
  addEventListener('scroll', () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { document.querySelectorAll('.nl-header').forEach(h => h.classList.toggle('nl-header--scrolled', scrollY > 30)); scheduled = false; });
  }, { passive:true });
  document.addEventListener('shopify:section:load', event => TF.init(event.target));
  document.addEventListener('shopify:section:unload', () => { if (!document.querySelector('dialog[open]')) document.body.classList.remove('nl-modal-open'); });
  TF.init();
})();
